import { render } from "./CreateNewMobileAppEvents.vue?vue&type=template&id=fb490bfe&scoped=true"
import script from "./CreateNewMobileAppEvents.vue?vue&type=script&lang=js"
export * from "./CreateNewMobileAppEvents.vue?vue&type=script&lang=js"

import "./CreateNewMobileAppEvents.vue?vue&type=style&index=0&id=fb490bfe&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb490bfe"]])

export default __exports__